import { Mp4Box } from "./Mp4Box.class";

export class free extends Mp4Box {}
